module.exports = __webpack_public_path__ + "img/edea285.png";